import { action, observable } from 'mobx';
// remove to fix snyk vulnerability
// this was bespoke to nuffield, and likely never to be used

// import { w3cwebsocket } from 'websocket';

class w3cwebsocket {
  constructor(fake: string) {}
}
// end fix
class Socket {
  private route: string = '';
  private ws: any;

  @observable readyState: number = 0;

  public constructor(port: number, type: string) {
    this.route = `ws://localhost:${port}/${type}`;
  }

  public connect() {
    this.ws = new w3cwebsocket(this.route);

    this.ws.onerror = this._onError;
    this.ws.onopen = this._onConnect;
    this.ws.onclose = this._onDisconnect;
    this.ws.onmessage = this._onMessage;
  }

  public disconnect() {
    this.ws.close();
  }

  public send(msg: string) {
    if (this.ws.readyState !== this.ws.OPEN) {
      //throw something
      return;
    }

    this.ws.send(msg);
  }

  @action.bound
  private _onConnect(e: any) {
    this.readyState = this.ws.readyState;
    this.onConnected();
  }

  @action.bound
  private _onMessage(e: any) {
    this.onMessage(e.data);
  }

  @action.bound
  private _onError(e: any) {
    this.readyState = this.ws.readyState;
    this.onError(e);
  }

  @action.bound
  private _onDisconnect(evt: any) {
    this.readyState = this.ws.readyState;
    this.onDisconnected(evt);
  }

  public onError = (evt: any) => {};
  public onConnected = () => {};
  public onDisconnected = (evt: any) => {};
  public onMessage = (msg: string) => {};
}

export default Socket;
